import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Form} from 'antd';
import {modal} from 'icsoc-antd-ex';
import IconFont from 'Components/common/iconFont';
import exportTasksActions from 'Actions/systemSetting/exportTasks';

const {ModalSize} = modal;

class DownloadModal extends Component {
  // 点击确定
  handleSubmit = () => {
    const {downloadModalData, setDownloadModalVisible} = this.props;
    Object.keys(downloadModalData).map(item =>
      window.open(downloadModalData[item]),
    );
    setDownloadModalVisible();
  };

  render() {
    const {setDownloadModalVisible, downloadModalData} = this.props;

    return (
      <ModalSize
        title="下载任务"
        centered
        maskClosable={false}
        visible
        okText="下载"
        onOk={this.handleSubmit}
        onCancel={setDownloadModalVisible}>
        {downloadModalData
          ? Object.keys(downloadModalData).map(item => (
              <div style={{marginBottom: 10}}>
                <IconFont type="icon-robotdetails" style={{marginRight: 10}} />
                {item}
              </div>
            ))
          : null}
      </ModalSize>
    );
  }
}

const mapStateToProps = ({systemSettingExportTasks}) => ({
  downloadModalData: systemSettingExportTasks.downloadModalData,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(exportTasksActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DownloadModal);
